export enum PageViewType {
  EVENT = 'EVENT',
  TICKETS = 'TICKETS',
}
